import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import {
  IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath';
import { IButtonWidget } from './IButtonWidget';
import {
  IButtonActionExecAsyncService,
  isButtonActionExecAsyncService,
} from './actions/IButtonAction';
import { getActionDataObjectName } from './getActionDataObjectName';

export function getButtonWidgetSiblingReferences(
  path: IReferencePath,
  widget: IButtonWidget,
): IReference[] {
  const serviceActions = widget.actions?.map((action, index) => ({
    action,
    index,
  }));

  const result: IReference[] = [];

  serviceActions?.forEach(action => {
    if (isButtonActionExecAsyncService(action.action)) {
      result.push(
        ...getExecAsyncServiceActionReference({
          action: action.action,
          index: action.index,
          widget,
          path,
        }),
      );
    }
  });

  return result;
}

function getExecAsyncServiceActionReference(params: {
  action: IButtonActionExecAsyncService;
  index: number;
  widget: IButtonWidget;
  path: IReferencePath;
}): IReference[] {
  const { action, index, widget, path } = params;
  return (
    action.outputs?.map(output => ({
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-${output.name}`,
      code: `${output.name}`,
      path: [
        ...path,
        {
          direction: ReferencePathDirection.Child,
          code: getActionDataObjectName(widget, index),
        },
      ],
      field: output.type,
      label: `${widget.code}: ${output.name}`,
    })) ?? []
  );
}
